import React from "react";
import "./ManualUpload.css";

export interface ManualUploadHeaderProps {
  title: string;
  description: string;
}

export const ManualUploadHeader: React.SFC<ManualUploadHeaderProps> = (props) => {
    return (
      <div className="ManualUpload-header">
        <div className="ManualUpload-title">{props.title}</div>
        <p className="ManualUpload-description">{props.description}</p>
        <div>{props.children}</div>
      </div>
    );
};



// WEBPACK FOOTER //
// ./src/manual-upload/ManualUploadHeader.tsx